// @flow

import { connect } from 'react-redux';

import ContactPage from './contactPage';

const mapStateToProps: Object = ({ siteConfigs }) => ({
  siteConfigs,
});

export default connect(mapStateToProps, {})(ContactPage);
